<script lang="ts">
import { defineComponent, h } from 'vue'
import { isString } from '@element-plus/utils'

export default defineComponent({
  name: 'TourContentRender',
  props: {
    content: {
      type: [String, Function],
      required: true,
    },
  },
  setup(props, { attrs }) {
    return () =>
      h(
        'div',
        {
          ...attrs,
        },
        isString(props.content) ? props.content : props.content()
      )
  },
})
</script>
